import lf from 'lovefield'

export function const_cubaturestypes (schemaBuilder) {
  schemaBuilder.createTable('const_cubaturestypes')
  	.addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addPrimaryKey(['code']);
}

/*
CREATE TABLE IF NOT EXISTS `const-cubaturestypes` (
  `code` varchar(3) NOT NULL,
  `nom` varchar(20) NOT NULL,
  PRIMARY KEY (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constCubaturestypes.schema.js